import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage } from 'srcReact/helpers/history'
import { decode } from 'html-entities/lib/index'
import Loader from 'srcReact/components/common2/Loader'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import { useTranslation } from 'react-i18next'
import Carousel from 'srcReact/components/common2/Carousel'

function Navigation({ type, list, loading, id, isMobile, isTablet, isDesktop }) {
  const [currentObject, setCurrentObject] = useState(null)
  const { t } = useTranslation()
  const [items, setItems] = useState([])
  const [itemsToShowInCarousel, setItemsToShowInCarousel] = useState(0)

  useEffect(() => {
    if (isDesktop) {
      setItemsToShowInCarousel(3)
    } else if (isTablet) {
      setItemsToShowInCarousel(2)
    } else {
      setItemsToShowInCarousel(1)
    }
  }, [isMobile, isTablet, isDesktop])
  useEffect(() => {
    if (list?.length > 0) {
      const data = list.map((item) => {
        const objectId = type === 'group' ? item.group_id : item.workplace_id
        return { text: item.name, href: `/0/dashboard/${type}/${objectId}`, id: objectId }
      })
      setItems(data)
      const index = data.findIndex((x) => {
        return x.id == id
      })

      setCurrentObject(data[index])
    }
  }, [id])

  const changeDashboard = (id) => {
    const index = items.findIndex((x) => {
      return x.id == id
    })
    setCurrentObject(items[index])
    redirectToPage(`/0/dashboard/${type}/${id}`)
  }

  return loading && list?.length === 0 ? (
    <Loader />
  ) : list?.length > 0 ? (
    <React.Fragment>
      {list.length > 1 && (
        <div className={styles.navigationContainer}>
          <Carousel
            itemsToShow={1}
            breakPoints={[{ width: 1, itemsToShow: itemsToShowInCarousel, itemsToScroll: 1 }]}
            itemsToSroll={1}
            initialActive={items.findIndex((x) => x.id == id)}
            className={styles.carouselWrapper}
            prevIconName='arrow-left24'
            nextIconName='arrow-right'
            itemPadding={[0, 0]}>
            {items.map((item, i) => {
              return (
                <button
                  key={item.id}
                  data-id={item.id}
                  className={`${styles.nameInCarousel} ${item.id === currentObject.id && styles.selected}`}
                  onClick={() => changeDashboard(item.id)}>
                  {item?.text && decode(item.text)}
                </button>
              )
            })}
          </Carousel>

          <ReactMenu
            ariaLabel={type === 'group' ? t('dashboard.showMoreGroups') : t('dashboard.showMoreWps')}
            options={items}
            menuButtonCSS={styles.menuButton}
            menuCSS={styles.menu}
            buttonIcon={'multiple-menu'}
          />
        </div>
      )}

      {!loading && (currentObject?.id || id) > 0 ? (
        <button
          className={styles.name}
          onClick={() => {
            const objectId = currentObject?.id || id
            if (type === 'group') {
              redirectToPage(`/0/home/${type}/${objectId}`)
            } else {
              redirectToPage(`/0/workplace/settings/${objectId}?section=link_1`)
            }
          }}>
          {currentObject?.text && decode(currentObject.text)}
        </button>
      ) : (
        <Loader />
      )}
    </React.Fragment>
  ) : null
}

export default Navigation
